<ng-container>
  <div *ngIf="showIsPrivate">
    <label class="form--label-with-check-box">
      <input
        name="work_package[is_private]"
        [disabled]="isDisabled"
        slot="input"
        type="checkbox"
        [ngModel]="isPrivate"
        (change)="onChange($event)"
      />
      {{ text.privateNote }}
    </label>
  </div>
  <div *ngIf="error" class="op-toast -error">
    <div class="op-toast--content">
      <p>
        <strong [textContent]="text.errorTitle"></strong>
        <br/>
        <span [textContent]="error"></span>
      </p>
    </div>
  </div>

  <div class="op-ckeditor-source-element document-editor" #opCkeditorReplacementContainer>
    <div class="document-editor__toolbar"></div>
    <div class="document-editor__editable-container">
      <div class="document-editor__editable">
      </div>
    </div>
  </div>
</ng-container>
